import { Outlet } from "react-router-dom";
import { AppLayout } from "@etframework/ui.components";
import { IconLoading } from "../components/Loading/IconLoading";
import useIsMounted from "../hooks/useIsMounted";

// Layout Components
import DueDatesTitleRow from "./components/DueDatesTitleRow";
import DueDatesNavigation from "./components/DueDatesNavigation";
import DueDatesAppheader from "./components/DueDatesAppHeader";
import { DueDatesRightPanel } from "./portals/DueDatesRightPanel";
import { OverlayOpener } from "./components/OverlayOpener";

// Portal Components
import { CreateTaskModal } from "./portals/CreateTaskModal";
import { TaskOverlay } from "./portals/TaskOverlay";
import { DeleteConfirmationModal } from "./portals/DeleteConfirmationModal";
import Notification from "./portals/Notification";
import { AccessModal } from "./portals/AccessModal";
import { CreateTaskTypeModal } from "./portals/CreateTaskTypeModal";
import { DeleteTaskTypeConfirmationModal } from "./portals/DeleteTaskTypeConfirmationModal";
import { CreateViewModal } from "./portals/CreateViewModal";
import { DeleteBoardConfirmationModal } from "./portals/DeleteBoardConfirmationModal";
import { ArchiveBoardConfirmationModal } from "./portals/ArchiveBoardConfirmationModal";
import { ImportTasksModal } from "./portals/ImportTasksModal";
import { DeleteViewConfirmationModal } from "./portals/DeleteViewConfirmationModal";
import { ExtendedDateModal } from "./portals/ExtendedDateModal";
import { UndoExtendedDateModal } from "./portals/UndoExtendedDateModal";
import { ImportTasksLogOverlay } from "./portals/ImportTasksLogOverlay";
import { WelcomeModal } from "./portals/WelcomeModal";
import { RolloverTasksModal } from "./portals/RolloverTasksModal";
import { BulkUpdateTasksModalFromGrid } from "./portals/BulkUpdateTasksModalFromGrid";
import { BulkUpdateTaskModalFromActions } from "./portals/BulkUpdateTaskModalFromActions";
import { CustomFieldGroupModal } from "./portals/CustomFieldGroupModal";
import { useTranslation } from "react-i18next";

//Providers
import { BoardProvider } from "../contexts/board/BoardProvider";
import { ViewsProvider } from "../contexts/views/ViewsProvider";
import { EntryPointProvider } from "../contexts/entry/EntryProvider";

const DueDatesLayout = () => {
  const isMounted = useIsMounted(true); // true to enforce delay
  const { t } = useTranslation(["Layout"], {
    useSuspense: false,
  });

  if (!isMounted) return <IconLoading />;

  return (
    <EntryPointProvider>
      <BoardProvider>
        <ViewsProvider>
          <AppLayout className="dashboard">
            <AppLayout.Header>
              <DueDatesAppheader />
            </AppLayout.Header>

            <AppLayout.TitleRow>
              <DueDatesTitleRow appName="Due Dates" boardName="Taxes" />
            </AppLayout.TitleRow>
            <div className="et-duedates-layout">
              <AppLayout.ContentRow>
                <AppLayout.Navigation>
                  <DueDatesNavigation />
                </AppLayout.Navigation>

                <AppLayout.MainContent
                  expandIconTooltip={t("Navigation.OpenSidebar")}
                >
                  <OverlayOpener>
                    <Outlet />
                  </OverlayOpener>
                </AppLayout.MainContent>

                <AppLayout.RightPanel>
                  <DueDatesRightPanel />
                </AppLayout.RightPanel>
              </AppLayout.ContentRow>
            </div>
            <AppLayout.Portals>
              <TaskOverlay />
              <ImportTasksLogOverlay />
              <CreateTaskModal />
              <CreateViewModal />
              <AccessModal />
              <DeleteConfirmationModal />
              <CreateTaskTypeModal />
              <DeleteTaskTypeConfirmationModal />
              <DeleteBoardConfirmationModal />
              <ArchiveBoardConfirmationModal />
              <DeleteViewConfirmationModal />
              <ImportTasksModal />
              <ExtendedDateModal />
              <UndoExtendedDateModal />
              <CustomFieldGroupModal />
              {/* Add above here */}
              <Notification />
              <WelcomeModal />
              <RolloverTasksModal />
              <BulkUpdateTasksModalFromGrid />
              <BulkUpdateTaskModalFromActions />
            </AppLayout.Portals>
          </AppLayout>
        </ViewsProvider>
      </BoardProvider>
    </EntryPointProvider>
  );
};

export default DueDatesLayout;
